<template>
  <FormItem :label="(label || 'label') + ':'" class="search-formItem">
    <Input size="small" :type="type" @input="$emit('change',$event)" v-model="dataValue"
           :placeholder="placeholder || '请输入'"
           class="search-input"/>
  </FormItem>
</template>

<script>
export default {
  name: 'search-form-item-input',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    label: String,
    placeholder: String,
    value: {
      type: [String, Number],
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    }
  },
  data () {
    return {
      dataValue: ''
    }
  },
  created () {
    this.dataValue = this.value
  },
  watch: {
    value (val) {
      this.dataValue = val
    }
  }
}
</script>
